<div class="chat-wrapper">
  <nav class="navbar navbar-dark bg-transparent card-glass p-3 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-3">
      <button title="back" class="btn btn-outline-light" (click)="goBack()"><i class="bi bi-arrow-left"></i></button>
      <div class="user-info d-flex align-items-center gap-2">
        <div>
          <h5 class="mb-0 text-white">{{contactName}}</h5>
          <small class="contusername">{{ contactUsername }}</small>
        </div>
      </div>
    </div>
    <div class="d-flex gap-2">
      <button title="call" class="btn btn-outline-light" (click)="startCall('audio')">
        <i class="bi bi-telephone-fill"></i>
      </button>
      <button title="videocall" class="btn btn-outline-light" (click)="startCall('video')">
        <i class="bi bi-camera-video-fill"></i>
      </button>
    </div>
  </nav>

  <!-- Incoming Call Popup (Receiver) -->
  <div *ngIf="incomingCall" class="call-popup-overlay">
    <div class="call-popup-content">
      <i [ngClass]="incomingCall.callType === 'video' ? 'bi bi-camera-video-fill' : 'bi bi-telephone-fill'"
        class="call-icon"></i>
      <h5>
        Incoming {{ incomingCall.callType }} call
        <span *ngIf="incomingCall.fromName">from <span class="caller-name">{{ incomingCall.fromName }}</span></span>

      </h5>
      <div class="call-popup-buttons">
        <button class="btn btn-success" (click)="acceptCall()">
          <i class="bi bi-telephone-inbound"></i> Accept
        </button>
        <button class="btn btn-danger" (click)="rejectCall()">
          <i class="bi bi-telephone-x"></i> Reject
        </button>
      </div>
    </div>
  </div>

  <!-- Ringing Overlay (Caller) -->
  <div *ngIf="ringing" class="ringing-overlay">
    <div class="ringing-content">
      <i [ngClass]="callType === 'video' ? 'bi bi-camera-video-fill' : 'bi bi-telephone-fill'" class="call-icon"></i>
      <h5>Calling {{ contactName }}...</h5>
      <div class="ringing-status">Ringing...</div>
      <button class="btn btn-danger mt-3" (click)="cancelCall()">
        <i class="bi bi-telephone-x"></i> Cancel
      </button>
    </div>
  </div>

  <!-- Call UI Overlay -->
  <div *ngIf="callActive" class="call-video-ui">
    <div class="video-container" *ngIf="callType === 'video'">
      <video #remoteVideo id="remoteVideo" autoplay class="remote-video"></video>
      <video #localVideo id="localVideo" autoplay muted class="local-video-float"></video>
    </div>
    <div class="audio-container" *ngIf="callType === 'audio'">
      <audio #remoteAudio id="remoteAudio" autoplay></audio>
      <div class="audio-avatar">
        <i class="bi bi-person-circle"></i>
        <!-- <span>{{ contactName[0] | uppercase }}</span> -->
      </div>
      <div class="audio-status">Audio call in progress...</div>
    </div>
    <button class="btn btn-danger end-call-btn" (click)="endCall()">
      <i class="bi bi-telephone-x"></i> End Call
    </button>
  </div>

  <!-- Chat Messages -->
  <div class="chat-messages p-3" #messagesContainer (scroll)="onScrollUp($event)">
    <div *ngFor="let msg of messages; let i = index" class="msg-row" [ngClass]="msg.from === 'me' ? 'right' : 'left'">
      <div class="msg" [ngClass]="msg.from === 'me' ? 'msg-right' : 'msg-left'"
        (contextmenu)="showContextMenu($event, i)" [class.deleted]="msg.isDeleted">
        <div *ngIf="msg.replyTo" class="reply-indicator">
          <small class="text-muted">Replying to:</small>
          <div class="reply-preview">{{getMessagePreview(msg.replyTo)}}</div>
        </div>
        <div class="message-content">
          {{ msg.isDeleted ? 'This message was deleted' : msg.text }}
        </div>
        <div class="message-meta">
          <small class="timestamp">{{ msg.timestamp | date:'shortTime' }}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat Input -->
  <div class="chat-input d-flex align-items-center gap-2 p-3 card-glass">
    <input type="text" (keydown.enter)="sendMessage()" [(ngModel)]="newMessage"
      class="form-control bg-transparent text-white border-secondary" placeholder="Type a message..." />
    <button title="send" class="btn btn-neon" (click)="sendMessage()">
      <i class="bi bi-send-fill"></i>
    </button>
  </div>
</div>
<app-spinner [show]="spinner" [message]="spinMessage" />